import styled from "styled-components";
import { Row } from "../../pages/Assets/style";

interface IContainerProps {
    isLink?: boolean
}
export const Container = styled(Row)<IContainerProps>`
    .wrapper  {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        cursor: ${props => props?.isLink ? 'pointer' : 'auto'};
    }
    .checkIcon {
        margin-left: 5px;
        circle {
            fill: #96da96;
        }
        path {
            fill: #036403;
        }
    }
`

export const Dots = styled.div`
    display: flex;
    flex-grow: 1;
    border: 1px dashed #a29b8b84;
    margin: 0 8px;
    margin-top: auto;
    margin-bottom: 5px;
`

export const Icon = styled.img`
    margin-left: 5px;
    cursor: pointer;
    &:hover {
        margin-left: 10px;
        transform: scale(1.2);
        transition: all 0.3s ease-in-out;
    }
`